<!--
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
-->
<!--
Program: Pagination
Author: SDL
Description: Pagination Common Component
-->
<template>
  <ul class="pagination b-pagination pagination-md justify-content-center">
    <li class="page-item" :class="[{ disabled: currentPage === 1 }]">
      <a href="#" class="page-link" @click.prevent="changePage(1)">≪</a>
    </li>
    <li class="page-item" :class="[{ disabled: currentPage <= 1 }]">
      <a href="#" class="page-link" @click.prevent="changePage(1 >= currentPage - 10 ? 1 : currentPage - 10)">
        {{ config.prevText }}
      </a>
    </li>
    <li v-for="num in pages" class="page-item" :class="[{ active: num === currentPage }]" :key="num">
      <a href="#" @click.prevent="changePage(num)" class="page-link">
        {{ num }}
      </a>
    </li>
    <li class="page-item" :class="[{ disabled: currentPage > lastPage }]">
      <a
        href="#"
        class="page-link"
        @click.prevent="changePage(currentPage > lastPage - 10 ? lastPage : currentPage + 10)"
        >{{ config.nextText }}</a
      >
    </li>
    <li class="page-item" :class="[{ disabled: currentPage === lastPage || lastPage === 0 }]">
      <a href="#" class="page-link" @click.prevent="changePage(lastPage)">≫</a>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'Pagination',
  props: {
    currentPage: {
      required: false,
      type: Number,
    },
    totalRows: {
      required: false,
      type: Number,
    },
    perPage: {
      required: false,
      type: Number,
    },
    limit: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      config: { prevText: '<', nextText: '>' },
      curPage: 1,
    };
  },
  created() {
    this.curPage = this.currentPage;
  },
  computed: {
    /**
     * param:
     * return:
     * exception:
     * Description : last page calculation
     */
    lastPage() {
      const total = this.totalRows / this.perPage;
      if (total < 1) return 1;

      if (total % 1 !== 0) return parseInt(total + 1, 10);

      return total;
    },
    /**
     * param:
     * return:
     * exception:
     * Description : page calculation to be shown
     */
    pages() {
      let from = Math.floor((this.currentPage - 1) / 10) * 10 + 1;
      let to = from + 9;
      if (to >= this.lastPage) to = this.lastPage;
      const arr = [];
      while (from <= to) {
        arr.push(from);
        from += 1;
      }
      if (this.totalRows === null) {
        arr.splice(0);
        arr.push(1);
      }
      return arr;
    },
  },
  methods: {
    /**
     * param:
     * return:
     * exception:
     * Description : Parents' change event call
     */
    changePage(page) {
      this.$emit('change', page);
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/common/control/pagination/Pagination.vue